export function CardColorIndicator({ color }: { color: string }) {
  return (
    <div
      style={{
        width: 4,
        height: "100%",
        borderRadius: "0 0 0 0",
        position: "absolute",
        left: 0,
        top: 0,
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
        backgroundColor: color === "Default" ? "transparent" : color,
      }}
    />
  )
}
